<template>
  <div class="page">
    <div class="formcontainer">
      <div class="formbox">
        <h2>Hizmet Sağlayıcılar İçin Başvuru Formu</h2>
        <tabs-basvuru current="4" hide="6"></tabs-basvuru>
        <br />
        <!-- <div class="formhead">
          <div>
            Bu sayfada ilettiğiniz bilgi ve belgeler listelenmektedir. Onaylamadan önce aşağıdaki
            bilgilerinizi kontrol edebilirsiniz.
            <br />
            Başvurunuza ait bilgiler size e-posta yoluyla gönderilecektir.
          </div>
        </div>-->

        <bilgi-boxes></bilgi-boxes>
        <div class="formpart">
          <div class="formfull">
            <h3>Marka Bilgileri</h3>

            <div v-if="application.brandSet && application.brandSet.length > 0">
              <div
                class="izintable"
                v-for="(item, index) in getBrands"
                :key="index"
              >
                <div class>
                  <form>
                    <div class="izinline">
                      <marka-show :brand="item" :editButtons="false" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="formpart formline">
          <div class="formfull">
            <h3>Yüklenen Belgeler</h3>

            <div class="filerow">
              <div
                v-for="(file, index) in sorted_fileSet"
                :key="index"
                class="fileline"
              >
                <div class="filetype">
                  {{ index + 1 }}-{{ belge_turu_map[file.docType].str }}
                </div>

                <img
                  :src="
                    require(`@/assets/img/file_${file.fileName
                      .split('.')
                      .pop()}.svg`)
                  "
                  alt
                />
                <div class="filename">{{ file.fileName }}</div>
                <div class="verif">
                  <img src="@/assets/img/ico_tick.svg" alt />
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="formpart">
          <div class="formfull">
            <div class="formline">
              <div class="check">
                <label class="labelcontainer">
                  <input type="checkbox" v-model="beyan_ok" />
                  <span class="checkmark"></span>
                </label>
                <h5>
                  Verdiğim tüm bilgilerin/belgelerin doğruluğunu beyan ederim.
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div class="formpart">
          <div class="formfull">
            <h3>Süreç nasıl ilerleyecek?</h3>

            <div class="desctext">
              <p>
                “Başvuruyu Tamamla” butonuyla başvurunuz hesap yöneticilerimize
                iletilecektir.
              </p>
              <p>
                Bilgileriniz/belgeleriniz hesap yöneticilerimiz tarafından
                kontrol edilerek bir değişiklik gerekmesi halinde belirttiğiniz
                iletişim kanalları üzerinden tarafınıza bildirim yapılacaktır.
              </p>
              <p>
                Bilgilerinizin/belgelerinizin tümünün doğruluğu sağlanana dek
                birkaç kez bildirim yapılabilir.
              </p>
              <p>
                Web sayfamızdaki ilgili bağlantıları takip ederek İleti Yönetim
                Sistemi hakkında detaylı bilgi edinebilir, Mevzuat ve Sıkça
                Sorulan Sorular bölümlerini inceleyebilirsiniz.
              </p>
            </div>
          </div>
        </div>

        <sonraki-bar label="Başvuruyu Tamamla" @next="NEXT" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import BilgiBoxes from "./genel/BilgiBoxes";
import MarkaShow from "./genel/MarkaShow";
import SonrakiBar from "./genel/SonrakiBar";

export default {
  name: "HSBasvuruOnaylama",

  components: {
    BilgiBoxes,
    MarkaShow,
    SonrakiBar,
  },

  data() {
    return {
      beyan_ok: false,
      belge_turu_map: require("../../../misc/enums").ENUM_BELGE_TURU,
    };
  },

  computed: {
    ...mapState("applicant", ["application"]),
    ...mapGetters("applicant", ["getBrands"]),

    sorted_fileSet() {
      return this.application.fileSet.sort((a, b) =>
        this.belge_turu_map[a.docType].order >
        this.belge_turu_map[b.docType].order
          ? 1
          : -1
      );
    },
  },

  methods: {
    ...mapActions("applicant", ["basvuruyu_onayla"]),

    ...mapMutations("applicant", ["SET_APPLICATION"]),

    NEXT() {
      if (!this.beyan_ok) {
        this.Alert(
          "Devam edebilmek için bilgilerinizin/belgelerinizin doğru olduğunu beyan etmeniz gereklidir."
        );
        return;
      }

      this.basvuruyu_onayla()
        .then((res) => {
          if (res.ok) {
            // _paq.push(["trackEvent", "Devam", "Devam_Onay", "Success"]);
            this.SET_APPLICATION(res.payload);
            this.$router.push("/hizmet-saglayici/basvuru/sonuc");
          }
        })
        .catch((cerror) => {
          // _paq.push(["trackEvent", "Devam", "Devam_Onay", "Error"]);
        });
    },
  },
};
</script>
